export const IOS_APP_STORE_URL = 'https://apps.apple.com/us/app/lexody/id1376288941'
export const ANDROID_PLAY_STORE_URL = 'https://play.google.com/store/apps/details?id=com.lexody.lexodyapp'

export function getMobilePlatform() {
  if (typeof navigator === 'undefined') {
    return null
  }

  const ua = navigator.userAgent || ''

  if (/iPad|iPhone|iPod/.test(ua)) {
    return 'ios'
  }

  if (/Android/i.test(ua)) {
    return 'android'
  }

  return null
}

export function openAppStore(platform) {
  const url = platform === 'ios' ? IOS_APP_STORE_URL : ANDROID_PLAY_STORE_URL
  window.open(url, '_blank', 'noopener,noreferrer')
}

export function openAppStoreForDevice() {
  const platform = getMobilePlatform()

  if (platform) {
    openAppStore(platform)
    return false
  }

  return true
}
